import React from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  useParams,
  Navigate,
  Outlet,
} from "react-router-dom";
import FullScreenLoading from "./components/loading";
import FullScreenAlert from "./components/alert";
import Client from "./pages/client";
import FrontDoor from "./pages/frontdoor";
import TermOfService from "./pages/TermOfService";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import LawInfo from "@/pages/LawInfo";

export default function App() {
  return (
    <div>
      <FullScreenLoading />
      <FullScreenAlert />
      <BrowserRouter>
        <Routes>
          <Route path="/lawInfo" exact element={<LawInfo />} />
          <Route path="/term_of_service" exact element={<TermOfService />} />
          <Route path="/privacy_policy" exact element={<PrivacyPolicy />} />
          <Route path="/:merchantId/*" element={<Outlet />}>
            <Route path="client/*" element={<Client />} />
            <Route index path="front/*" element={<FrontDoor />} />
            <Route path="/:merchantId/*" element={<Navigate to="client" />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}
